module.exports = __webpack_public_path__ + "img/0869f46d743d4f15b637f69bd551506d.svg";